import { Brand } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'

import { CommonState } from 'embed/reducers'
import { ContactEven, ContactFiona } from 'embed/constants'
import { loanPurposeIsAutomobileRefinanceSelector, loanPurposeIsSLRSelector } from 'embed/selectors/application'
import { brandSelector } from 'embed/selectors/config'
import { formattedPhoneNumber } from 'embed/utils'

interface StoreProps {
  brand?: string
  isSLR?: boolean
  isAutoRefi?: boolean
}

const EvenPersonalLoanDisclosure = (
  <>
    <p>
      We do not charge any fee or cost to submit a loan request on www.evenfinancial.com. The actual loan rate depends
      on the loan amount and term requested, as well as your credit score, usage and history. If you are offered a loan,
      you will have the opportunity to review the final offer made by the lender or lending partner, and to accept the
      loan agreement made directly between you and the lender or lending partner. The lenders and lending partners we
      work with may charge an origination fee for facilitating the loan to you. For example, on a $10,000 loan with a 5%
      origination fee, you will incur a $500 origination fee and receive $9,500 upon successful issuance of your loan.
      Rate, terms and fees will be based on your individual credit history and underwritten by the lender and not by
      Even Financial, Inc. ("Even”, “Even Financial”, “we”, “us”, “our”)
    </p>
    <p>
      Please note, our lenders' and lending partners' privacy policy and security practices may differ from Even
      Financial standards. Even Financial assumes no responsibility, nor does it control, endorse or guarantee any
      aspect of your use of the linked site. All rates, fees, and terms are presented without guarantee and are subject
      to change pursuant to each provider's discretion and may not be available in all states or for all types of loans.
      There is no guarantee you will be approved or qualify for the advertised rates, fees, or terms presented. This
      website does not include all lending companies or all available lending offers that may be available to you.
    </p>
    <p>
      Representative Example: If you borrow $5,000 on a 36 month repayment term and at a 10% APR, the monthly repayment
      will be $161.34. Total repayment will be $5,808.24. Total interest paid will be $808.24.
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: The Annual Percentage Rate is the rate at which your loan accrues
      interest. It is based upon the amount of your loan, the cost of the loan, term of the loan, repayment amounts and
      timing of payments and payoff. By law, the lender or lending partner must show you the APR before you enter into
      the loan. States have laws that may limit the APR that the lender or lending partner can charge you. Rates will
      vary based on your credit worthiness, loan size, amongst other variables, with the lowest rates available to
      customers with excellent credit. Minimum and maximum loan amounts and APRs may vary according to state law and
      lender or lending partner. We recommend that you read the lender's and/or lending partner's personal terms and
      conditions in full before proceeding for any loan.
    </p>
    <p>
      Requirements, discounts or other terms and conditions will vary by lender. We recommend that you read the lender's
      and/or lending partner's personal terms and conditions, as well as any disclosures, in full before proceeding for
      any loan.
    </p>
    <p>
      Please note that any type of secured loan is tied to a financial asset that you already own and will be used as
      collateral to pay your loan should you not be able to pay. In some cases, a lender may keep a lien on the
      collateral until the loan is fully repaid.
    </p>
    <p>
      Even Financial, Inc. is the technology platform powering financial services online. Even's API enables its
      partners to connect their users with real-time decisions and personalized offers and rates from premium financial
      services providers. Even Financial offices are located at 50 West 23rd Street, Suite 700, New York, NY 10010,
      Telephone number: {formattedPhoneNumber(ContactEven.Phone)}. This site is directed at, and made available to,
      persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const FionaPersonalLoanDisclosure = (
  <>
    <p>
      We do not charge any fee or cost to submit a loan request on www.fiona.com. The actual loan rate depends on the
      loan amount and term requested, as well as your credit score, usage and history. If you are offered a loan, you
      will have the opportunity to review the final offer made by the lender or lending partner, and to accept the loan
      agreement made directly between you and the lender or lending partner. The lenders and lending partners we work
      with may charge an origination fee for facilitating the loan to you. For example, on a $10,000 loan with a 5%
      origination fee, you will incur a $500 origination fee and receive $9,500 upon successful issuance of your loan.
      Rate, terms and fees will be based on your individual credit history and underwritten by the lender and not by
      Even Financial, Inc. / Fiona ("Even”, “Even Financial”, ”Fiona”, “we”, “us”, “our”)
    </p>
    <p>
      Please note, our lenders' and lending partners' privacy policy and security practices may differ from Fiona
      standards. Fiona assumes no responsibility, nor does it control, endorse or guarantee any aspect of your use of
      the linked site. All rates, fees, and terms are presented without guarantee and are subject to change pursuant to
      each provider's discretion and may not be available in all states or for all types of loans. There is no guarantee
      you will be approved or qualify for the advertised rates, fees, or terms presented. This website does not include
      all lending companies or all available lending offers that may be available to you.
    </p>
    <p>
      Representative Example: If you borrow $5,000 on a 36 month repayment term and at a 10% APR, the monthly repayment
      will be $161.34. Total repayment will be $5,808.24. Total interest paid will be $808.24.
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: The Annual Percentage Rate is the rate at which your loan accrues
      interest. It is based upon the amount of your loan, the cost of the loan, term of the loan, repayment amounts and
      timing of payments and payoff. By law, the lender or lending partner must show you the APR before you enter into
      the loan. States have laws that may limit the APR that the lender or lending partner can charge you. Rates will
      vary based on your credit worthiness, loan size, amongst other variables, with the lowest rates available to
      customers with excellent credit. Minimum and maximum loan amounts and APRs may vary according to state law and
      lender or lending partner. We recommend that you read the lender's and/or lending partner's personal terms and
      conditions in full before proceeding for any loan.
    </p>
    <p>
      Requirements, discounts or other terms and conditions will vary by lender. We recommend that you read the lender's
      and/or lending partner's personal terms and conditions, as well as any disclosures, in full before proceeding for
      any loan.
    </p>
    <p>
      Please note that any type of secured loan is tied to a financial asset that you already own and will be used as
      collateral to pay your loan should you not be able to pay. In some cases, a lender may keep a lien on the
      collateral until the loan is fully repaid.
    </p>
    <p>
      Even Financial, Inc. is the technology platform powering financial services online. Even's API enables its
      partners to connect their users with real-time decisions and personalized offers and rates from premium financial
      services providers. Even Financial offices are located at 50 West 23rd Street, Suite 700, New York, NY 10010,
      Telephone number: {formattedPhoneNumber(ContactFiona.Phone)}. This site is directed at, and made available to,
      persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const EvenSLRDisclosure = (
  <>
    <p>
      We do not charge any fee or cost to submit a refinance/consolidation loan request on www.evenfinancial.com. The
      actual loan rate depends on the loan amount and term requested, as well as your credit score, usage, and history.
      If you are offered a loan, you will have the opportunity to review the final offer made by the lender or lending
      partner, and to accept the loan agreement made directly between you and the lender or lending partner. The lenders
      and lending partners we work with may charge an origination fee for facilitating the loan to you. For example, on
      a $10,000 loan with a 5% origination fee, you will incur a $500 origination fee and receive $9,500 upon successful
      issuance of your loan. Rate, terms and fees will be based on your individual credit history and underwritten by
      the lender and not by Even Financial, Inc. ("Even”, “Even Financial”, “we”, “us”, “our”)
    </p>
    <p>
      Please note, our lenders' and lending partners' privacy policy and security practices may differ from Even
      Financial standards. Even Financial assumes no responsibility, nor does it control, endorse or guarantee any
      aspect of your use of the linked site. All rates, fees, and terms are presented without guarantee and are subject
      to change pursuant to each provider's discretion and may not be available in all states or for all types of loans.
      There is no guarantee you will be approved or qualify for the advertised rates, fees, or terms presented. This
      website does not include all lending companies or all available lending offers that may be available to you.
    </p>
    <p>
      Representative Example: If you borrow $5,000 on a 36 month repayment term and at a 10% APR, the monthly repayment
      will be $161.34. Total repayment will be $5,808.24. Total interest paid will be $808.24.
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: The Annual Percentage Rate is the rate at which your loan accrues
      interest. It is based upon the amount of your loan, the cost of the loan, term of the loan, repayment amounts and
      timing of payments and payoff. By law, the lender or lending partner must show you the APR before you enter into
      the loan. States have laws that may limit the APR that the lender or lending partner can charge you. Rates will
      vary based on your credit worthiness, loan size, amongst other variables, with the lowest rates available to
      customers with excellent credit. Minimum and maximum loan amounts and APRs may vary according to state law and
      lender or lending partner.
    </p>
    <p>
      Student loan refinancing or consolidation may result in certain penalties, restrictions, changes in payments, loss
      of certain benefits, and/or eligibility that may apply for certain federal and private loans. Some requirements
      and restrictions may include loan minimum and maximum requirements, age, degree and educational institution
      requirements, citizenship and residency requirements as well as other lender requirements. Student loan refinance
      partners offer fixed rates ranging from 2.83%-8.77% and variable interest rates ranging from 1.97%-8.94%. Variable
      rates will fluctuate over the term of the loan. Students may also qualify for Federal student financial
      assistance. Additional information can be found at{' '}
      <a href="https://studentaid.gov" target="_blank">
        https://studentaid.gov
      </a>
    </p>
    <p>
      Refinancing any loan may not always result in lower overall interest and principal payments and in many cases it
      can extend the life of the loan. Requirements, discounts or other terms and conditions will vary by lender.
    </p>
    <p>
      We recommend that you read the lender's and/or lending partner's personal terms and conditions, as well as any
      disclosures, in full before proceeding for any loan.
    </p>
    <p>
      Even Financial, Inc. is the technology platform powering financial services online. Even's API enables its
      partners to connect their users with real-time decisions and personalized offers and rates from premium financial
      services providers. Even Financial offices are located at 50 West 23rd Street, Suite 700, New York, NY 10010,
      Telephone number: {formattedPhoneNumber(ContactEven.Phone)}. This site is directed at, and made available to,
      persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const FionaSLRDisclosure = (
  <>
    <p>
      We do not charge any fee or cost to submit a refinance/consolidation loan request on www.evenfinancial.com /
      www.fiona.com. The actual loan rate depends on the loan amount and term requested, as well as your credit score,
      usage, and history. If you are offered a loan, you will have the opportunity to review the final offer made by
      lender or lending partner, and to accept the loan agreement made directly between you and the lender or lending
      partner. The lenders and lending partners we work with may charge an origination fee for facilitating the loan to
      you. For example, on a $10,000 loan with a 5% origination fee, you will incur a $500 origination fee and receive
      $9,500 upon successful issuance of your loan. Rate, terms and fees will be based on your individual credit history
      and underwritten by the lender and not by Even Financial, Inc. / Fiona ("Even”, “Even Financial”, ”Fiona”, “we”,
      “us”, “our”)
    </p>
    <p>
      Please note, our lenders' and lending partners' privacy policy and security practices may differ from Fiona
      standards. Fiona assumes no responsibility, nor does it control, endorse or guarantee any aspect of your use of
      the linked site. All rates, fees, and terms are presented without guarantee and are subject to change pursuant to
      each provider's discretion and may not be available in all states or for all types of loans. There is no guarantee
      you will be approved or qualify for the advertised rates, fees, or terms presented. This website does not include
      all lending companies or all available lending offers that may be available to you.
    </p>
    <p>
      Representative Example: If you borrow $5,000 on a 36 month repayment term and at a 10% APR, the monthly repayment
      will be $161.34. Total repayment will be $5,808.24. Total interest paid will be $808.24.
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: The Annual Percentage Rate is the rate at which your loan accrues
      interest. It is based upon the amount of your loan, the cost of the loan, term of the loan, repayment amounts and
      timing of payments and payoff. By law, the lender or lending partner must show you the APR before you enter into
      the loan. States have laws that may limit the APR that the lender or lending partner can charge you. Rates will
      vary based on your credit worthiness, loan size, amongst other variables, with the lowest rates available to
      customers with excellent credit. Minimum and maximum loan amounts and APRs may vary according to state law and
      lender or lending partner.
    </p>
    <p>
      Student loan refinancing or consolidation may result in certain penalties, restrictions, changes in payments, loss
      of certain benefits, and/or eligibility that may apply for certain federal and private loans. Some requirements
      and restrictions may include loan minimum and maximum requirements, age, degree and educational institution
      requirements, citizenship and residency requirements as well as other lender requirements. Our student loan
      refinance partners offer fixed rates ranging from 2.83%-8.77% and variable interest rates ranging from
      1.97%-8.94%. Variable rates will fluctuate over the term of the loan. Students may also qualify for Federal
      student financial assistance. Additional information can be found at{' '}
      <a href="https://studentaid.gov" target="_blank">
        https://studentaid.gov
      </a>
    </p>
    <p>
      Refinancing any loan may not always result in lower overall interest and principal payments and in many cases it
      can extend the life of the loan. Requirements, discounts or other terms and conditions will vary by lender.
    </p>
    <p>
      We recommend that you read the lender's and/or lending partner's personal terms and conditions, as well as any
      disclosures, in full before proceeding for any loan.
    </p>
    <p>
      Even Financial, Inc. is the technology platform powering financial services online. Even's API enables its
      partners to connect their users with real-time decisions and personalized offers and rates from premium financial
      services providers. Even Financial offices are located at 50 West 23rd Street, Suite 700, New York, NY 10010,
      Telephone number: {formattedPhoneNumber(ContactFiona.Phone)}. This site is directed at, and made available to,
      persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const FionaAutoRefiDisclosure = (
  <>
    <p>
      We do not charge any fee or cost to submit a refinance/consolidation loan request on www.evenfinancial.com /
      www.fiona.com. The actual loan rate depends on the loan amount and term requested, as well as your credit score,
      usage, history and other factors. If you are offered a loan, you will have the opportunity to review the final
      offer made by lender or lending partner, and to accept the loan agreement made directly between you and the lender
      or lending partner. The lenders and lending partners we work with may charge an origination fee for facilitating
      the loan to you. For example, on a $10,000 loan with a 5% origination fee, you will incur a $500 origination fee
      and receive $9,500 upon successful issuance of your loan. Rate, terms and fees will be based on your individual
      credit history and underwritten by the lender and not by Even Financial, Inc. / Fiona ("Even”, “Even Financial”,
      ”Fiona”, “we”, “us”, “our”)
    </p>
    <p>
      Please note, our lenders' and lending partners' privacy policy and security practices may differ from Fiona
      standards. Fiona assumes no responsibility, nor does it control, endorse or guarantee any aspect of your use of
      the linked site. All rates, fees, and terms are presented without guarantee and are subject to change pursuant to
      each provider's discretion and may not be available in all states or for all types of loans. There is no guarantee
      you will be approved or qualify for the advertised rates, fees, or terms presented. Rates may change depending on
      several factors such as having a cosigner. Our partners offer both fixed and variable rates. Variable rates will
      fluctuate over the term of the loan.This website does not include all lending companies or all available lending
      offers that may be available to you.
    </p>
    <p>
      Representative Example: If you borrow $5,000 on a 36 month repayment term and at a 10% APR, the monthly repayment
      will be $161.34. Total repayment will be $5,808.24. Total interest paid will be $808.24.
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: The Annual Percentage Rate is the rate at which your loan accrues
      interest. It is based upon the amount of your loan, the cost of the loan, term of the loan, repayment amounts and
      timing of payments and payoff. By law, the lender or lending partner must show you the APR before you enter into
      the loan. States have laws that may limit the APR that the lender or lending partner can charge you. Rates will
      vary based on your credit worthiness, loan size, amongst other variables, with the lowest rates available to
      customers with excellent credit. Minimum and maximum loan amounts and APRs may vary according to state law and
      lender or lending partner.
    </p>
    <p>
      The automobile payments displayed do not include taxes, licensing and fees. The actual interest rate, annual
      percentage rate and payment may vary based on the specific terms of the automobile loan selected, verification of
      your credit history, license, taxes, fees, money down, trade-in, rebates, cash down, and type of automobile as
      well as other factors as determined by lenders. Certain institutions may include minimum and/or maximum loan
      amounts based on several factors such as your income, key credit characteristics, and the vehicle you are
      refinancing. Restrictions as to the type of vehicle and age of the vehicle and other characteristics may also
      apply. Our automobile refinance partners offer APRs between 1.49%-12%. Variable rates will fluctuate over the term
      of the loan.
    </p>
    <p>
      Refinancing any loan may not always result in lower overall interest and principal payments and in many cases it
      can extend the life of the loan. Requirements, discounts or other terms and conditions will vary by lender. We
      recommend that you read the lender's and/or lending partner's personal terms and conditions, as well as any
      disclosures, in full before proceeding for any loan.
    </p>
    <p>
      Please note that any type of secured loan is tied to a financial asset that you already own and will be used as
      collateral to pay your loan should you not be able to pay. In some cases, a lender may keep a lien on the
      collateral until the loan is fully repaid.
    </p>
    <p>
      Even Financial, Inc. is the technology platform powering financial services online. Even's API enables its
      partners to connect their users with real-time decisions and personalized offers and rates from premium financial
      services providers. Even Financial offices are located at 50 West 23rd Street, - Suite 700, New York, NY 10010,
      Telephone number: {formattedPhoneNumber(ContactFiona.Phone)}. This site is directed at, and made available to,
      persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const EvenAutoRefiDisclosure = (
  <>
    <p>
      We do not charge any fee or cost to submit a refinance/consolidation loan request on www.evenfinancial.com. The
      actual loan rate depends on the loan amount and term requested, as well as your credit score, usage, history and
      other factors. If you are offered a loan, you will have the opportunity to review the final offer made by lender
      or lending partner, and to accept the loan agreement made directly between you and the lender or lending partner.
      The lenders and lending partners we work with may charge an origination fee for facilitating the loan to you. For
      example, on a $10,000 loan with a 5% origination fee, you will incur a $500 origination fee and receive $9,500
      upon successful issuance of your loan. Rate, terms and fees will be based on your individual credit history and
      underwritten by the lender and not by Even Financial, Inc. ("Even”, “Even Financial”, “we”, “us”, “our”)
    </p>
    <p>
      Please note, our lenders' and lending partners' privacy policy and security practices may differ from Even
      Financial standards. Even Financial assumes no responsibility, nor does it control, endorse or guarantee any
      aspect of your use of the linked site. All rates, fees, and terms are presented without guarantee and are subject
      to change pursuant to each provider's discretion and may not be available in all states or for all types of loans.
      There is no guarantee you will be approved or qualify for the advertised rates, fees, or terms presented. Rates
      may change depending on several factors such as having a cosigner. Our partners offer both fixed and variable
      rates. Variable rates will fluctuate over the term of the loan.This website does not include all lending companies
      or all available lending offers that may be available to you.
    </p>
    <p>
      Representative Example: If you borrow $5,000 on a 36 month repayment term and at a 10% APR, the monthly repayment
      will be $161.34. Total repayment will be $5,808.24. Total interest paid will be $808.24.
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: The Annual Percentage Rate is the rate at which your loan accrues
      interest. It is based upon the amount of your loan, the cost of the loan, term of the loan, repayment amounts and
      timing of payments and payoff. By law, the lender or lending partner must show you the APR before you enter into
      the loan. States have laws that may limit the APR that the lender or lending partner can charge you. Rates will
      vary based on your credit worthiness, loan size, amongst other variables, with the lowest rates available to
      customers with excellent credit. Minimum and maximum loan amounts and APRs may vary according to state law and
      lender or lending partner.
    </p>
    <p>
      The automobile payments displayed do not include taxes, licensing and fees. The actual interest rate, annual
      percentage rate and payment may vary based on the specific terms of the automobile loan selected, verification of
      your credit history, license, taxes, fees, money down, trade-in, rebates, cash down, and type of automobile as
      well as other factors as determined by lenders. Certain institutions may include minimum and/or maximum loan
      amounts based on several factors such as your income, key credit characteristics, and the vehicle you are
      refinancing. Restrictions as to the type of vehicle and age of the vehicle and other characteristics may also
      apply. Our automobile refinance partners offer APRs between 1.49%-12%. Variable rates will fluctuate over the term
      of the loan.
    </p>
    <p>
      Refinancing any loan may not always result in lower overall interest and principal payments and in many cases it
      can extend the life of the loan. Requirements, discounts or other terms and conditions will vary by lender. We
      recommend that you read the lender's and/or lending partner's personal terms and conditions, as well as any
      disclosures, in full before proceeding for any loan.
    </p>
    <p>
      Please note that any type of secured loan is tied to a financial asset that you already own and will be used as
      collateral to pay your loan should you not be able to pay. In some cases, a lender may keep a lien on the
      collateral until the loan is fully repaid.
    </p>
    <p>
      Even Financial, Inc. is the technology platform powering financial services online. Even's API enables its
      partners to connect their users with real-time decisions and personalized offers and rates from premium financial
      services providers. Even Financial offices are located at 50 West 23rd Street, - Suite 700, New York, NY 10010,
      Telephone number: {formattedPhoneNumber(ContactEven.Phone)}. This site is directed at, and made available to,
      persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const LoanDisclosure: React.SFC<StoreProps> = ({ brand, isSLR, isAutoRefi }) => {
  let disclosure
  if (brand === Brand.Fiona) {
    if (isSLR) {
      disclosure = FionaSLRDisclosure
    } else if (isAutoRefi) {
      disclosure = FionaAutoRefiDisclosure
    } else {
      disclosure = FionaPersonalLoanDisclosure
    }
  } else {
    if (isSLR) {
      disclosure = EvenSLRDisclosure
    } else if (isAutoRefi) {
      disclosure = EvenAutoRefiDisclosure
    } else {
      disclosure = EvenPersonalLoanDisclosure
    }
  }

  return (
    <>
      <p>
        <strong>Additional Information</strong>
      </p>
      {disclosure}
    </>
  )
}

const mapStateToProps = (state: CommonState) => ({
  brand: brandSelector(state),
  isAutoRefi: loanPurposeIsAutomobileRefinanceSelector(state),
  isSLR: loanPurposeIsSLRSelector(state),
})

export default connect(mapStateToProps)(LoanDisclosure)
